var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightTabbarTradeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light_tabbar_trade_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB8EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB8EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB8EB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-107, -59)",
    stroke: "#0E1C39",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(107, 59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(3, 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0006503,-4.88498131e-15 C15.0008386,2.18975227 16.9471782,5.71343384 16.9471782,9.6872685 C16.9471782,13.6611032 15.0008386,17.1847847 12.0006503,19.374537 C8.99797232,17.1855675 7.05120029,13.6615445 7.05120029,9.6872685 C7.05120029,5.76242813 8.94984207,2.27670921 11.8872405,0.0816004905 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9991893,10.5781183 C18.0649461,10.5781183 23.092101,14.9814809 23.9985673,20.7362146 C22.5249099,21.3656831 20.9016345,21.7137413 19.1962641,21.7137413 C13.1305073,21.7137413 8.10335235,17.3103787 7.19688609,11.5556451 C8.66996944,10.9262996 10.2935173,10.5781183 11.9991893,10.5781183 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9991893,10.5781183 C13.7045596,10.5781183 15.327835,10.9261766 16.8005225,11.5544688 C15.8950262,17.3103787 10.8678712,21.7137413 4.8021144,21.7137413 C3.09644249,21.7137413 1.47289459,21.36556 9.99200722e-15,20.7370576 C0.906277501,14.9814809 5.93343242,10.5781183 11.9991893,10.5781183 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(107, 59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(3, 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0006503,-4.88498131e-15 C15.0008386,2.18975227 16.9471782,5.71343384 16.9471782,9.6872685 C16.9471782,13.6611032 15.0008386,17.1847847 12.0006503,19.374537 C8.99797232,17.1855675 7.05120029,13.6615445 7.05120029,9.6872685 C7.05120029,5.76242813 8.94984207,2.27670921 11.8872405,0.0816004905 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9991893,10.5781183 C18.0649461,10.5781183 23.092101,14.9814809 23.9985673,20.7362146 C22.5249099,21.3656831 20.9016345,21.7137413 19.1962641,21.7137413 C13.1305073,21.7137413 8.10335235,17.3103787 7.19688609,11.5556451 C8.66996944,10.9262996 10.2935173,10.5781183 11.9991893,10.5781183 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9991893,10.5781183 C13.7045596,10.5781183 15.327835,10.9261766 16.8005225,11.5544688 C15.8950262,17.3103787 10.8678712,21.7137413 4.8021144,21.7137413 C3.09644249,21.7137413 1.47289459,21.36556 9.99200722e-15,20.7370576 C0.906277501,14.9814809 5.93343242,10.5781183 11.9991893,10.5781183 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-3)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTabbarTradeSelected);
export default __webpack_public_path__ + "static/media/light_tabbar_trade_selected.dc076173a8df9a6a869ebf5d3ebb2baa.svg";
export { ForwardRef as ReactComponent };